import React from 'react';
import NodeWrapper from './NodeWrapper';
import OptionsNode from './OptionsNode';
import { ICONIFY } from '../../../Constants/iconify';

function DropdownTextfieldNode({ data, isConnectable }) {

    return (
        <NodeWrapper nodeId={data?.id}>
            <OptionsNode
                data={data}
                icon={ICONIFY.DROPDOWN_TEXT_FIELD}
            />
        </NodeWrapper>
    );
};

export default DropdownTextfieldNode